import styled from 'styled-components';

export const StyledSearchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    overflow: hidden;
    padding-right: 6px;
    width: 100%;
    max-width: ${({ expanded, fullWidth, small }) => fullWidth ? '100%' : expanded && small ? '180px' : expanded && !small ? '280px' : '38px'};
    border: 1px solid ${({ expanded, theme }) => expanded ? theme.colors.lightGrey : 'transparent'};
    transition: all 0.3s;
`;

export const StyledSearchWrapper = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const StyledSearch = styled.input`
  ${({ theme }) => theme.fonts.mulishLight};
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.025em;
  color: ${({ theme, color }) => color ? color : theme.colors.darkGrey};
  border: 0;
  outline: 0;
  padding: 10px 15px;
  border-radius: 5px;
  width: 100%;
  ::placeholder {
    color: ${({ theme }) => theme.colors.mediumGrey};
  };
`;
